import { siteName, siteTagline } from "@/mocks/works";

const stats = [
  { value: "180+", label: "精选作品" },
  { value: "12w+", label: "同好评价" },
  { value: "36期", label: "持续更新" },
];

export default function Hero() {
  return (
    <section id="home" className="relative flex min-h-[640px] w-full items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=warm%20artistic%20anime%20illustration%20of%20a%20cozy%20evening%20home%20scene%20with%20a%20tender%20couple%20silhouette%20by%20warm%20lamp%20light%2C%20soft%20terracotta%20and%20cream%20tone%2C%20dreamy%20storybook%20atmosphere%2C%20soft%20bokeh%20lights%2C%20warm%20and%20romantic%2C%20high%20detail&width=1600&height=900&seq=hero-renqi-2026&orientation=landscape"
        alt="还得是人妻动漫首屏背景，温馨的婚后居家场景"
        className="absolute inset-0 h-full w-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/55 via-foreground-950/40 to-foreground-950/65"></div>

      <div className="relative z-10 mx-auto w-full max-w-4xl px-4 pt-28 pb-24 text-center md:px-6">
        <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-xs font-medium text-background-50 ring-1 ring-background-50/30 backdrop-blur-sm">
          <i className="ri-heart-3-fill text-accent-400" aria-hidden="true"></i>
          {siteTagline}
        </span>

        <h1 className="mt-6 font-heading text-3xl leading-tight font-black text-background-50 md:text-5xl md:leading-tight">
          还得是人妻动漫
          <span className="mt-2 block text-xl font-bold text-background-50/90 md:text-3xl">
            推荐 · 盘点 · 排行 · 口碑，一站精选同好人气佳作
          </span>
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-background-50/85 md:text-base">
          {siteName} 专注人妻动漫题材的内容推荐平台。我们梳理同好口碑与讨论热度，帮你快速锁定值得一看的婚后恋爱、
          家庭日常、治愈温情作品，省去反复筛选的时间，每期更新，还有真实评价参考。
        </p>

        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href="#ranking"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-semibold text-background-50 hover:bg-primary-600 transition-colors sm:w-auto"
          >
            查看人气排行
            <i className="ri-trophy-line text-base" aria-hidden="true"></i>
          </a>
          <a
            href="#recommend"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-background-50/15 px-7 py-3 text-sm font-semibold text-background-50 ring-1 ring-background-50/40 backdrop-blur-sm hover:bg-background-50/25 transition-colors sm:w-auto"
          >
            浏览作品推荐
            <i className="ri-book-open-line text-base" aria-hidden="true"></i>
          </a>
        </div>

        <div className="mx-auto mt-12 grid max-w-xl grid-cols-3 gap-4">
          {stats.map((s) => (
            <div key={s.label} className="rounded-xl bg-background-50/10 px-3 py-4 ring-1 ring-background-50/20 backdrop-blur-sm">
              <p className="font-heading text-2xl font-bold text-accent-300 md:text-3xl">{s.value}</p>
              <p className="mt-1 text-xs text-background-50/80">{s.label}</p>
            </div>
          ))}
        </div>
      </div>

      <a
        href="#categories"
        className="absolute bottom-6 left-1/2 z-10 -translate-x-1/2 flex h-10 w-10 items-center justify-center rounded-full bg-background-50/15 text-background-50 ring-1 ring-background-50/30 backdrop-blur-sm hover:bg-background-50/30 transition-colors animate-bounce"
        aria-label="向下浏览"
      >
        <i className="ri-arrow-down-line text-lg" aria-hidden="true"></i>
      </a>
    </section>
  );
}